import { useEffect, useState, useContext } from "react";
import { Card, CardContent, Typography, Box, Drawer, TextField } from "@mui/material";
import { PCPChangesContext } from "../../../../context/PatientContext/PCPChangesContext/PCPChangesContext";
import PCPChangesDetail from "./PatientMapComp/Table/PCPChangesDetail";
import TableTools from "../Complements/TableTools";
import { columnsPCPChanges } from "../../../../themes/ColumsTools";
import ColumnSelector from "../Complements/ColumnSelector";

    
const PCPChanges = () => {
    const [selectedCenter, setSelectedCenter] = useState('All');
    const [selectedRow, setSelectedRow] = useState(null);
    const [detailOpen, setDetailOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [PCPChanges] = useState({});
    const {
        PCPChangesPatients: rows,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        total,
        fetchPCPChangesDetails
    } = useContext(PCPChangesContext);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});

    const handleAddPatient = (newPatient) => {
        setData(prev => {
            const exists = prev.some(patient => patient.cipId === newPatient.cipId);
            if (exists) {
            return prev.map(patient =>
                patient.cipId === newPatient.cipId ? newPatient : patient
            );
            } else {
            return [...prev, newPatient];
            }
        });
    };

    const[data,setData]=useState([])
    useEffect(() => {
    }, []);

    const handleRowClick = (row) => {
        setSelectedRow(row);
        fetchPCPChangesDetails(row.cipId);
        setDetailOpen(true);
    };
    
  return (
    <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
            PCP Changes
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
            <TextField
                placeholder="Member Name"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ width: '60%' }}
            />
            <ColumnSelector
                columns={columnsPCPChanges}
                columnVisibilityModel={columnVisibilityModel}
                setColumnVisibilityModel={setColumnVisibilityModel}
            />
        </Box>
        <Box sx={{ borderBottom: '1px solid #ddd', mb: 2 }} />
        {/* Contenedor principal en fila */}
        <Box sx={{ display: 'flex', gap: 2 }}>
            
            {/* Sidebar */}
            <Box
                sx={{
                    width: 200,
                    pr: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}
                >
                {Object.entries(PCPChanges).map(([key, value]) => (
                <Box
                    key={key}
                    onClick={() => setSelectedCenter(key)}
                    sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    backgroundColor: selectedCenter === key ? '#d1f2eb' : 'transparent',
                    borderRadius: '999px',
                    px: 2,
                    py: 0.5,
                    fontWeight: selectedCenter === key ? 'bold' : 'normal',
                    border: selectedCenter === key ? '1px solid #117a65' : 'none',
                    color: selectedCenter === key ? '#117a65' : 'inherit',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#d1f2eb',
                    },
                    }}
                >
                    {key}{' '}
                    <span style={{ color: '#aaa', marginLeft: 4 }}>
                    ({value || 0})
                    </span>
                </Box>
                ))}

            </Box>
            {/* Contenido principal con la tabla */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Card>
                    <CardContent sx={{ p: 0 }}>
                    <Box 
                        sx={{ 
                        height: 700, 
                        overflowY: "auto"
                        }}
                    >
                        <TableTools
                            rows={rows}
                            loading={loading}
                            page={page}
                            pageSize={pageSize}
                            rowCount={total}
                            setPage={setPage}
                            setPageSize={setPageSize}
                            columns={columnsPCPChanges}
                            onRowClick={handleRowClick}
                            columnVisibilityModel={columnVisibilityModel}
                            setColumnVisibilityModel={setColumnVisibilityModel}
                        />
                    </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
        <Drawer anchor="right" open={detailOpen} onClose={() => setDetailOpen(false)}>
            <Box width={650} p={3}>
                <PCPChangesDetail
                    modificar={ selectedRow?? [] }
                    open={detailOpen}
                    onClose={() => setDetailOpen(false)}
                    onSave={(newReferral) => {
                        handleAddPatient(newReferral);
                        setDetailOpen(false);
                    }}
                />
            </Box>
        </Drawer>
    </Box>
    
  );
};


export default PCPChanges;

